export default "__VITE_ASSET__BouXvlx1__"